// extracted by mini-css-extract-plugin
export default {"container":"Oq-z","heading":"Pq-z","text":"Qq-z","info":"Rq-z","link":"Sq-z","fullMaxWidth":"Tq-z"};